<script lang="ts">
    import { trans } from '$assets/shop-translator.js';
    import cn from '$common/utils/cn';
    import NumberInput from '$saga/components/NumberInput.svelte';
    import { TOUR_TYPE_GIR, TYPEBOOKING_EBOOKING } from '$saga/constants/tour';

    import { alignAgesWithCount } from './utils';

    export let ageRules,
        minAgeAllowed,
        maxAgeAllowed,
        tourType,
        bookingType,
        formValues,
        maxRuleValue,
        minRuleValue,
        dateStatusName;
    const isEbookingType = bookingType === TYPEBOOKING_EBOOKING;
    const isGir = tourType === TOUR_TYPE_GIR;
</script>

<div
    class={cn(
        'flex items-center justify-between gap-2xs',
        ageRules.max.isUnder18Allowed && 'hidden',
    )}
>
    <label for="nbAdults" class="flex text-content-neutral">
        {#if isEbookingType}
            <span class="text-sm">
                {trans('tour.aside_panel.pax_popover.adults.label')}
                <!-- 18ans et plus -->
                {#if (!minAgeAllowed || minAgeAllowed < 18) && !maxAgeAllowed}
                    {trans(
                        'tour.aside_panel.pax_popover.adults.no_min_age_and_no_max_age',
                    )}
                {/if}
                <!-- de 18ans à X -->
                {#if (!minAgeAllowed || minAgeAllowed < 18) && maxAgeAllowed >= 18}
                    {trans(
                        'tour.aside_panel.pax_popover.adults.no_min_age_and_max_age_under_xxx',
                        {
                            '%age%': String(maxAgeAllowed),
                        },
                    )}
                {/if}
                <!--de X ans à Y ans -->
                {#if minAgeAllowed >= 18 && maxAgeAllowed >= 18}
                    {trans(
                        'tour.aside_panel.pax_popover.adults.min_age_older_xxx_and_max_age_under_yyy',
                        {
                            '%minAge%': String(minAgeAllowed),
                            '%maxAge%': String(maxAgeAllowed),
                        },
                    )}
                {/if}
            </span>
        {:else}
            <span class="font-semibold">
                {trans('tour.aside_panel.pax_popover.amount')}
            </span>
        {/if}
    </label>
    <NumberInput
        bind:value={formValues.adults}
        max={maxRuleValue}
        min={minRuleValue}
        id="nbAdults"
        name="nbAdults"
        minusBtnClasses={formValues.adults === minRuleValue
            ? 'text-bord-quiet'
            : undefined}
        minusBtnProps={{ disabled: formValues.adults === minRuleValue }}
        onDecrement={() => {
            if (formValues.adults > minRuleValue) {
                formValues.adults = formValues.adults - 1;
                formValues.adultsAges = alignAgesWithCount(
                    formValues.adultsAges,
                    formValues.adults,
                );
            }
        }}
        onInput={() => {
            formValues.adultsAges = alignAgesWithCount(
                formValues.adultsAges,
                formValues.adults,
            );
        }}
        plusBtnClasses={maxRuleValue === formValues.adults
            ? 'text-bord-quiet'
            : undefined}
        plusBtnProps={{ disabled: maxRuleValue === formValues.adults }}
        onIncrement={() => {
            if (maxRuleValue == null || maxRuleValue > formValues.adults) {
                formValues.adults = formValues.adults + 1;
                formValues.adultsAges = alignAgesWithCount(
                    formValues.adultsAges,
                    formValues.adults,
                );
            }
        }}
    />
</div>

{#if formValues.selectedDate && !isEbookingType && isGir}
    <div class="mt-m">
        <strong> {dateStatusName}</strong>
        <p class="text-content-quiet">
            {trans('tour.dates.status.confirm')}
        </p>
    </div>
{/if}
